import Vue from "vue";
import Vuex from "vuex";

import service from "../../services/workflow/schedule";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    paddingNav: "247px",
    schedules: [],
    segments: [],
    scheduleId: null,
    segmentId: null,
    sequence: [],
  },

  mutations: {
    setSchedules(state, data) {
      state.schedules = data;
    },
    setSegments(state, data) {
      state.segments = data;
    },
    setScheduleId(state, data) {
      state.scheduleId = data;
    },

    setSegmentId(state, data) {
      state.segmentId = data;
    },
    setSequence(state, data) {
      state.sequence = data;
    },
  },
  actions: {
    async getSchedules(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getSchedules();
          state.commit("setSchedules", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getSegments(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getSegment(state.state.scheduleId);
          state.commit("setSegments", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async getSequence(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getSequence(
            state.state.scheduleId,
            state.state.segmentId
          );
          state.commit("setSequence", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
